import vCountdown from "./v-countdown.vue";

export default Vue => {
  Vue.component("v-countdown", vCountdown);
};
